import CheckIcon from "@mui/icons-material/Check";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Typography } from "@mui/material";

export const ActiveItemTrending = ({
  trend,
  trendColor,
  trendDate,
  dataIcon,
}: {
  trend: number | string;
  trendColor?: string;
  trendDate?: string;
  dataIcon?: string;
}) =>
  Number(trend) !== 0 && (
    <Typography variant="caption" sx={{ color: trendColor, ml: 1, display: "flex", alignItems: "center" }} noWrap>
      {dataIcon === "warning" ? (
        <WarningAmberIcon sx={{ width: 12, height: 12, color: trendColor, mr: 0.25 }} />
      ) : dataIcon === "trending down" ? (
        <TrendingDownIcon sx={{ width: 12, height: 12, color: trendColor, mr: 0.25 }} />
      ) : dataIcon === "suggestion" ? (
        <SettingsSuggestIcon sx={{ width: 12, height: 12, color: trendColor, mr: 0.25 }} />
      ) : dataIcon === "check" ? (
        <CheckIcon sx={{ width: 12, height: 12, color: trendColor, mr: 0.25 }} />
      ) : dataIcon === "trending up" ? (
        <TrendingUpIcon sx={{ width: 12, height: 12, color: trendColor, mr: 0.25 }} />
      ) : (
        <></>
      )}
      {trendDate ? `+${trend} since ${trendDate}` : trend}
    </Typography>
  );
